import { ITableColumn } from '@makyoapp/makyo-sdk/models/Table'

import { Cell, ICell } from '.'

/**
 * This file defines the structure and behavior of text cells in a table.
 * It includes interfaces for text columns and cells, as well as a TextCell class
 * that implements the ITextCell interface. The TextCell class provides methods
 * for converting cell values to strings and creating new cells from string values.
 */

export interface ITextColumn extends ITableColumn {
  Settings: null
}

export interface ITextCell extends ICell {
  settings: null
}

export class TextCell implements ITextCell {
  value: Cell
  settings: null

  constructor(value: Cell, settings: null) {
    this.value = value
    this.settings = settings
  }

  toString(): string {
    if (this.value === null || this.value === undefined) {
      return ''
    }
    if (typeof this.value === 'number' && isNaN(this.value)) {
      return '#N/A'
    }
    let stringVal = this.value?.toString()

    if (stringVal === '_CELL_LOADING_') return ''

    if (!stringVal?.trim()) return ''

    // todo remove non-printable for some unichars
    // return stringVal.toString().replaceAll(/[\x00-\x1F\x7F-\xFF]/g, '<non-printable>')
    return stringVal.toString()
  }

  toCell<T extends Cell>(newValue: T) {
    if (!newValue || typeof newValue !== 'string') {
      this.value = ''
      return this
    }
    this.value = newValue
    return this
  }
}
